module.exports = __webpack_public_path__ + "static/media/udacity_logo.6cd287c6.png";